<template>
  <div class="staff-page">
    <el-dialog class="dislog-box" :visible="visible" top="0vh" width="512px" center :show-close="false" @close="onClose">
      <div class="dislog-content">
        <div class="staff-info-box">
          <div class="scroll-box">
            <div class="group-box" v-for="item in staffs" :key="item.seniority">
              <div class="tit-box">
                <div class="divider"></div>
                <div class="seniority">{{item.seniority}} 年员工</div>
                <div class="divider end"></div>
              </div>
              <div class="list-box">
                <div class="item-box" v-for="it in item.group" :key="it.id">
                  <div class="avatar"><img v-if="+it.status && it.file" :src="it.file" width="100%" height="100%"/></div>
                  <div class="intro">
                    <span class="nickname">{{it.nickName}}</span>
                    <span class="divider"></span>
                    <span class="name">{{it.department | staffDepartment}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      staffs: []
    }
  },
  filters: {
    staffStatus (val) {
      if (+val === 0) return '离职'
      else if (+val === 1) return '在职'
    },
    staffDepartment (val) {
      if (+val === 0) return '创始人'
      else if (+val === 1) return '总经办'
      else if (+val === 2) return '产研'
      else if (+val === 3) return '职能'
      else if (+val === 4) return '运营'
    },
    userStatus (val) {
      if (+val === 1) return '正常'
      else if (+val === 8) return '禁用'
      else return '未知'
    }
  },
  created () {
    this.getStaffs()
  },
  methods: {
    onClose () {
      this.$emit('change', false)
    },
    getStaffs () {
      return this.$store.dispatch('staffQueryStaffInfos', {}).then(res => {
        let { GroupData } = res
        let list = []
        for (let key in GroupData) {
          if (GroupData[key] && GroupData[key].length) {
            list.unshift({seniority: key, group: GroupData[key]})
          }
        }
        list[0].group.forEach(it => {
          if (it.id === 1) it.sort = 9
          else if (it.id === 437) it.sort = 8
          else if (it.id === 431) it.sort = 7
          else if (it.id === 432) it.sort = 6
          else it.sort = 0
        })
        list.forEach((it, ind) => {
          it.group.sort((a, b) => b.status - a.status)
          if (ind === 0) it.group.sort((a, b) => b.sort - a.sort)
        })
        this.staffs = list
      })
    }
  }
}
</script>

<style lang="less" scoped>
.staff-page {
  .dislog-box {
    /deep/.el-dialog {
      background: #fff0;
      box-shadow: none;
      margin-bottom: 0;
      .el-dialog__header {
        display: none;
      }
      .el-dialog__body {
        padding: 0;
      }
    }
  }
}
.dislog-content {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .staff-info-box {
    width: 512px;
    height: 780px;
    background-image: url('./img/bj.png');
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 84px 0px 50px;
    .scroll-box {
      width: 100%;
      height: 100%;
      padding: 10px 64px 0px;
      box-sizing: border-box;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 0px;
        height: 0px;
      }
      scrollbar-width: none;
      -ms-overflow-style: none;
    }
    .group-box {
      width: 100%;
      .tit-box {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .divider {
          width: 102px;
          height: 2px;
          background-image: url('./img/divider.png');
          background-size: 100% 100%;
          &.end {
            transform: rotateY(180deg);
          }
        }
        .seniority {
          font-size: 14px;
          color: #fff;
        }
      }
      .list-box {
        width: 100%;
        padding: 16px 0;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .item-box {
          width: 50%;
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          box-sizing: border-box;
          justify-content: flex-end;
          padding-right: 24px;
          &:nth-child(2n) {
            justify-content: flex-start;
            padding-right: 0;
            padding-left: 24px;
          }
          .avatar {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            overflow: hidden;
            // background-color: #efefef;
            margin-right: 10px;
          }
          .intro {
            font-size: 14px;
            color: #fff;
            display: flex;
            align-items: center;
            span {
              display: inline-block;
              &.nickname {
                min-width: 36px;
                margin-right: 4px;
              }
              &.divider {
                width: 10px;
                height: 1px;
                background-color: #fff;
                margin-right: 5px;
                margin-top: 1px;
              }
              &.name {
                min-width: 42px;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/staffDialog/index.vue